import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getVehiclesActions, clearVehiclesActions } from '../../redux/actions/vehiclesActions';

const useFetchVehicles = () => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.vehicles?.search);
  const vehicles = useSelector((state) => state.vehicles?.vehicles);
  const loading = useSelector((state) => state.vehicles?.loading);

  const fetchVehicles = useCallback(async () => {
    await dispatch(getVehiclesActions(search));
  }, [search, dispatch]);

  useEffect(() => {
    fetchVehicles();
  }, [fetchVehicles]);

  useEffect(() => {
    return () => {
      dispatch(clearVehiclesActions());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchVehicles();
  };

  return { loading, vehicles, refresh };
};

export default useFetchVehicles;
